import styled, { css } from 'styled-components';
import Modal from 'react-modal';

// 모달 스타일 설정
Modal.setAppElement('#root');

export const StyledModal = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 32px 24px 32px 24px;
  border-radius: 8px;
  max-width: 90%;
  width: 560px;
  outline: none;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #1e1f1f;
  line-height: 28px;
  margin: 0;
`;

export const SubText = styled.p`
  margin: 8px 0 0 0;
  font-size: 15px;
  font-weight: 400;
  color: #48484a;
  line-height: 22px;
`;

export const ButtonContainer = styled.div`
  padding-top: 16px;
  margin: 8px 0 0 0;
  display: flex;
  gap: 16px;
`;

const buttonCommon = css`
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  padding: 16px 32px;
  height: 56px;
  transition: background 0.2s;
`;

export const LeftButton = styled.button`
  ${buttonCommon}
  flex: 1;
  background: white;
  color: #000;
  &:hover {
    background: #e3e3e4;
  }
`;

export const RightButton = styled.button`
  ${buttonCommon}
  flex: 2;
  background: #3d51ff;
  color: #fff;
  &:hover {
    color: #d5daff;
  }
`;
